export default class StorageService {
  static getItem = (name: string): string => localStorage.getItem(name) ?? '';
  static setItem = (name: string, value: string): void => localStorage.setItem(name, value);
  static removeItem = (name: string): void => localStorage.removeItem(name);
}
